import Layout from "../components/ui/layout";
import useDocumentTitle from "../utils/useDocumentTitle";
import contactData from "../data/contactData.json";
import {useEffect} from "react";
import contactAnimation from "../utils/contactSectionAnimation";
import {GithubSVG, LinkedInSVG, MailSVG} from "../components/ui/icons";
import {Card, CardBody} from "@nextui-org/card";
import {Link} from "react-router";
import {Button} from "@nextui-org/button";

const Contact = () => {

    useDocumentTitle('Mahri Ilmedova | Contact')

    const { email, github, linkedIn } = contactData;

    useEffect(() => {
        const mq = window.matchMedia("(min-width: 1024px)");
        if (!mq.matches) return contactAnimation.mobileAnimation();

        contactAnimation.emailAnimation();
        contactAnimation.githubAnimation();
        contactAnimation.linkedInAnimation();
        contactAnimation.formAnimation();
    }, []);

    return (
        <Layout>
            <section className="pb-12 max-w-6xl m-auto overflow-hidden 2xl:overflow-visible">
                <div className="grid grid-rows-2 grid-cols-2 gap-5 max-w-2xl mx-auto">
                    <Card
                        className="col-span-full lg:row-start-1 lg:row-span-1 lg:col-span-1 opacity-0 mobile-animation emailCard py-2">
                        <CardBody className="flex flex-row justify-center items-center gap-2">
                            <Button
                                className="text-green-700 bg-green-100 dark:text-gray-100 dark:bg-zinc-700"
                                startContent={<MailSVG size={50} color={"currentColor"} />}>
                                {email}
                            </Button>
                        </CardBody>
                    </Card>

                    <Card
                        isHoverable
                        className="col-span-full lg:row-start-2 lg:row-span-1 lg:col-span-1 cursor-pointer opacity-0 mobile-animation linkedInCard py-2"
                    >
                        <Link
                            to={linkedIn}
                            rel="noopener noreferrer"
                            target="_blank"
                            className="min-h-full flex justify-center items-center"
                        >
                            <CardBody
                                className="flex justify-center items-center text-[#0077b5]"
                                onClick={() => window.open(`${linkedIn}`, "_blank")}
                            >
                                {/* <XSVG /> */}
                                <LinkedInSVG color={"currentColor"} size={50}/>
                            </CardBody>
                        </Link>
                    </Card>

                    <Card
                        isHoverable
                        className="col-span-full lg:row-start-1 lg:row-span-2 lg:col-start-2 cursor-pointer opacity-0 mobile-animation githubCard py-2"
                    >
                        <Link
                            to={github}
                            rel="noopener noreferrer"
                            target="_blank"
                            className="min-h-full flex justify-center items-center"
                        >
                            <CardBody className="flex justify-center items-center gap-2">
                                <GithubSVG color={"currentColor"} size={50}/>
                                <h1 className="text-3xl font-bold">Github Profile</h1>
                                <p className="text-xl text-gray-700 dark:text-gray-400  text-center">
                                    Find more of my repositories
                                </p>
                            </CardBody>
                        </Link>
                    </Card>

                </div>
            </section>
        </Layout>
    )
}

export default Contact;
